import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 65 65"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "m23.221 23.027 19.335 19.335m-19.335 0 19.335-19.335"
    }, null, -1),
    _createElementVNode("rect", {
      width: "64",
      height: "64",
      x: ".5",
      y: ".5",
      stroke: "currentColor",
      rx: "32"
    }, null, -1)
  ]))]))
}
export default { render: render }